import { useCalendarSettings } from '../../../storages';
import type { CalendarSearchParamsOptions } from '../../../types';
import { CalendarLayoutContent } from './calendar-layout-content';
import { useGetCalendarEvents } from './hooks';

type P = {
  date: Date;
  getPathToEventDetail: (id: string) => string;
  navigateToEventDetail: (id: string) => Promise<void>;
  updateSearchParams: CalendarSearchParamsOptions['updateSearchParams'];
};

const MainContent = ({ date, getPathToEventDetail, navigateToEventDetail, updateSearchParams }: P) => {
  const [{ layout, mode }] = useCalendarSettings();
  const { events, isFetching } = useGetCalendarEvents({ date, mode });

  return (
    <div className="calendar-main-content-wrapper">
      <CalendarLayoutContent
        date={date}
        events={events}
        getPathToEventDetail={getPathToEventDetail}
        isLoading={isFetching}
        layout={layout}
        mode={mode}
        navigateToEventDetail={navigateToEventDetail}
        updateSearchParams={updateSearchParams}
      />
    </div>
  );
};

export default MainContent;
